import { useTranslation } from "react-i18next";
import { NeedsListView } from "./NeedsListView";

export const Behovsliste = () => {
  const { t } = useTranslation();
  return (
    <NeedsListView
      title={t("Needs overview")}
      description={t("All registered needs.")}
      mineOnly={false}
      urlStatusSync={true}
    />
  );
};
